import * as React from "react";
import { Link } from "react-router-dom";
import { FieldNav } from "../components/FieldNav.js";
import { FieldFooter } from "../components/FieldFooter.js";
import { useDocumentTitle } from "../hooks/useDocumentTitle.js";
import "../styles/landing-field.css";
import "../styles/content-pages-field.css";

export function NotFoundRoute(): React.ReactElement {
  // Every caller (PracticeGradeRoute, PracticeTopicRoute, RequireStaff, the
  // test-landing reserved-slug guard, etc.) reaches this component after data
  // failed to load or access was denied — without this, the tab would keep
  // showing whichever page's title loaded last, indefinitely.
  useDocumentTitle("Page Not Found — Sports Academy Games");
  // The SPA returns HTTP 200 for unknown paths (Vercel serves index.html), so a
  // misspelled URL would otherwise be indexable. Tell crawlers not to index it.
  // Scoped to this route: removed on unmount so a later navigation doesn't
  // inherit the noindex.
  React.useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);
  return (
    <div className="v-field">
      <FieldNav />
      <main id="main" className="v-field-c__page">
        <div className="container">
          <div className="v-field-c__center">
            <span className="v-field-c__eyebrow">Error 404</span>
            <h1 className="v-field-c__title">
              Out of <span className="stripe">bounds.</span>
            </h1>
            <p className="v-field-c__lede">
              That page didn't load. It may have moved or never existed.
            </p>
            <div className="v-field-c__actions">
              <Link to="/" className="btn-field-primary">
                Back home
              </Link>
              <Link to="/games" className="btn-field-secondary">
                Browse games
              </Link>
            </div>
          </div>
        </div>
      </main>
      <FieldFooter />
    </div>
  );
}
